import ArcScroll from './ArcScroll';
import BlurScroll from './BlurScroll';
import FadeScroll from './FadeScroll';
import FlipScroll from './FlipScroll';
import GrowScroll from './GrowScroll';
import MoveScroll from './MoveScroll';
import PanScroll from './PanScroll';
import ParallaxScroll from './ParallaxScroll';
import RevealScroll from './RevealScroll';
import ShapeScroll from './ShapeScroll';
import ShuttersScroll from './ShuttersScroll';
import ShrinkScroll from './ShrinkScroll';
import SkewPanScroll from './SkewPanScroll';
import SlideScroll from './SlideScroll';
import Spin3dScroll from './Spin3dScroll';
import SpinScroll from './SpinScroll';
import StretchScroll from './StretchScroll';
import TiltScroll from './TiltScroll';
import TurnScroll from './TurnScroll';
export const scrollAnimations = {
  ArcScroll,
  BlurScroll,
  FadeScroll,
  FlipScroll,
  GrowScroll,
  MoveScroll,
  PanScroll,
  ParallaxScroll,
  RevealScroll,
  ShapeScroll,
  ShuttersScroll,
  ShrinkScroll,
  SkewPanScroll,
  SlideScroll,
  Spin3dScroll,
  SpinScroll,
  StretchScroll,
  TiltScroll,
  TurnScroll
};
//# sourceMappingURL=index.js.map